import AOS from 'aos'

document.addEventListener('DOMContentLoaded', (event) => {
  AOS.init({
    offset: 0,
    duration: 1000,
    once: true
  })
})